import { useTranslation } from 'react-i18next';

import { Books, Notes } from '@cfa/system-icons';

import useAuth from '@/hooks/useAuth';

import Fab from '@/components/Fab/Fab';
import FabPopupItem from '@/components/Fab/FabPopupItem';

interface AddPlanFabProps {
  showAddPlanMenu: boolean;
  setShowAddPlanMenu: (show: boolean) => void;
  onBuildCustomPlan: () => void;
  onChooseFromLibrary: () => void;
}

const AddPlanFab: React.FC<AddPlanFabProps> = ({
  showAddPlanMenu,
  setShowAddPlanMenu,
  onBuildCustomPlan,
  onChooseFromLibrary,
}) => {
  const { t } = useTranslation();
  const { data: auth } = useAuth();
  const locationsWithAtLeastLeaderRole =
    auth?.allLocationsWithAtLeastLeaderRoles ?? [];

  if (!locationsWithAtLeastLeaderRole.length) {
    return null;
  }

  return (
    <Fab
      isOpen={showAddPlanMenu}
      onClick={() => setShowAddPlanMenu(!showAddPlanMenu)}
      onClose={() => setShowAddPlanMenu(false)}
      icon="plan-plus"
    >
      <FabPopupItem
        data-testid="CustomPlan"
        icon={<Notes />}
        onClick={onBuildCustomPlan}
        title={t('TrainingPlans.addPlanMenu.buildCustomPlan')}
      />
      <FabPopupItem
        data-testid="TemplateLibraryPlan"
        icon={<Books />}
        onClick={onChooseFromLibrary}
        title={t('TrainingPlans.addPlanMenu.choosePlanFromLibrary')}
      />
    </Fab>
  );
};

export default AddPlanFab;
